var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLineaTitulo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_2",
    "data-name": "Capa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 886.07 44.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #f5dfbb;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #127475;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    y: 17.95,
    width: 866.79,
    height: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 864.05,
    cy: 22.02,
    r: 11.34
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M864.05,44.04c-12.14,0-22.02-9.88-22.02-22.02s9.88-22.02,22.02-22.02,22.02,9.88,22.02,22.02-9.88,22.02-22.02,22.02h0ZM864.05,5.29c-9.23,0-16.73,7.51-16.73,16.73s7.51,16.73,16.73,16.73,16.73-7.51,16.73-16.73-7.51-16.73-16.73-16.73Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineaTitulo);
export default __webpack_public_path__ + "static/media/lineaTitulo.a1242b0b14752801c7fc917dfe097907.svg";
export { ForwardRef as ReactComponent };